var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('Logo'),_c('h1',[_vm._v("建立你的帳號")]),_c('div',{staticClass:"form-wrapper"},[_c('AccountDetailForm',{attrs:{"is-processing":_vm.isProcessing},on:{"after-register":_vm.handleAfterSubmit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }